import { Button, Modal } from 'react-bootstrap';
import { ExternalData } from '../../../@types/external-api';
import './index.scss';

interface ModalComponentProps {
  show: boolean;
  onHide: () => void;
  onConfirm?: () => void;
  confirmationModal?: boolean;
  title?: string;
  body?: string | ExternalData<string[]>;
}

export function ModalComponent({
  show,
  onHide,
  onConfirm,
  title,
  body,
  confirmationModal,
}: ModalComponentProps) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="paginated-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {typeof body === 'string' ? (
          <p>{body}</p>
        ) : (
          <ul>
            {body?.data?.map((data, index) => (
              <li key={index}>{data}</li>
            ))}
          </ul>
        )}
      </Modal.Body>
      {confirmationModal ? (
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="secondary" onClick={onConfirm}>
            Delete
          </Button>
        </Modal.Footer>
      ) : (
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
}